export default "__VITE_ASSET__yalmNqtX__"